import styled from 'styled-components'
import { useModal } from 'hooks'
import withRenderModal from 'hocs/withRenderModal'
import MainModal from 'modals/MainModal'

import HeadingPrimary from '../components/Heading/Primary'
import Heading from '../share-ui/components/Heading/Heading'
import TypographySecondary from '../components/Typography/Secondary'
import { StyledSuccessPaymentInfoContainer } from '../styles/successPaymentStyles.css'
import { useTranslation } from 'react-i18next'

const SuccessPaymentModal = () => {
    const { closeModal } = useModal()
    const { t } = useTranslation()

    return (
        <MainModal onClose={() => closeModal('success-payment-modal')} title={''}>
            <StyledModalBody>
                <StyledBox>
                    <StyledSuccessPaymentInfoContainer>
                        <HeadingPrimary
                            value={'Card Added Successfully!'}
                            type={Heading.types?.h1}
                            style={{ fontSize: 32, lineHeight: 'normal', fontWeight: 600 }}
                        />

                        <TypographySecondary
                            value={t(
                                'Your card has been added successfully. You can now use it for automatic billing and transactions.',
                            )}
                            size='medium'
                        />
                    </StyledSuccessPaymentInfoContainer>
                </StyledBox>
            </StyledModalBody>
        </MainModal>
    )
}
export default withRenderModal('success-payment-modal')(SuccessPaymentModal)

export const StyledModalBody = styled.div`
    padding: 20px;
    padding-top: 0;

    width: 90vw;
    max-width: 700px;
    min-width: 400px;

    height: auto;
`

const StyledBox = styled.div`
    margin-top: 16px;
`
